<template>
    <span
        class="kgr-tooltip kgr-tooltip--noHover kgr-tooltip--bottom kgr-tooltip--styled"
        :class="{ 'is-open': isOpen }"
    >
        <span
            class="kgr-tooltip__trigger cursor-pointer underline"
            @click.stop="toggle()"
        >
            {{ voucherNumber }}
        </span>
        <span
            class="kgr-tooltip__content min-w-75"
            @click.stop
        >
            <kgr-loading
                v-if="loading"
                inline
            />
            <template v-else-if="voucherData">
                <p class="mb-2 font-bold text-lg">Informationen von ISBJ über diesen Gutschein</p>
                <table class="w-full whitespace-nowrap">
                    <tr
                        v-for="(value, key) in voucherData"
                        :key="key"
                    >
                        <td class="font-bold pr-2 align-top">
                            {{ key }}
                        </td>
                        <td class="align-top">
                            {{ formatValue(value) }}
                        </td>
                    </tr>
                </table>
            </template>
            <template v-else-if="hasError">
                {{ 'Gutscheindaten konnten nicht abgerufen werden.' }}
            </template>
        </span>
    </span>
</template>

<script>
import IsbjChildRepository from '../../../js/repository/IsbjChildRepository';
import Loading from '../../common/Loading';

export default {
    components: {
        'kgr-loading': Loading,
    },
    props: {
        voucherNumber: {
            type: String,
            required: true,
        },
        federationId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isOpen: false,
            loading: false,
            voucherData: null,
            hasError: false,
        };
    },
    mounted() {
        document.addEventListener('click', this.closeOnOutsideClick);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeOnOutsideClick);
    },
    methods: {
        toggle() {
            if (this.isOpen) {
                this.isOpen = false;
                return;
            }
            this.isOpen = true;
            if (this.voucherData !== null) {
                return;
            }
            this.fetchVoucherDetail();
        },
        async fetchVoucherDetail() {
            this.loading = true;
            this.hasError = false;
            try {
                this.voucherData = await IsbjChildRepository.getVoucherDetail(this.federationId, this.voucherNumber);
                this.loading = false;
            } catch {
                this.hasError = true;
                this.loading = false;
            }
        },
        closeOnOutsideClick() {
            if (this.isOpen) {
                this.isOpen = false;
            }
        },
        formatValue(value) {
            if (value === null || value === undefined) {
                return '-';
            }
            if (typeof value === 'object') {
                return JSON.stringify(value);
            }
            return String(value);
        },
    },
};
</script>
